var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnboardingEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9826 4.01742C19.4548 3.48969 18.5992 3.48969 18.0715 4.01742L9.02703 13.0619L9.02703 14.973H10.9381L19.9826 5.92852C20.5103 5.40079 20.5103 4.54516 19.9826 4.01742ZM16.9248 2.87076C18.0858 1.70975 19.9682 1.70975 21.1292 2.87076C22.2902 4.03178 22.2902 5.91416 21.1292 7.07518L11.8473 16.3571C11.6952 16.5092 11.489 16.5946 11.274 16.5946H8.21622C7.76842 16.5946 7.4054 16.2316 7.4054 15.7838L7.4054 12.726C7.4054 12.511 7.49083 12.3047 7.64288 12.1527L16.9248 2.87076ZM4.97297 5.78379C4.22664 5.78379 3.62162 6.38881 3.62162 7.13514V19.027C3.62162 19.7734 4.22664 20.3784 4.97297 20.3784H16.8649C17.6112 20.3784 18.2162 19.7734 18.2162 19.027V13.6216C18.2162 13.1738 18.5792 12.8108 19.027 12.8108C19.4748 12.8108 19.8378 13.1738 19.8378 13.6216V19.027C19.8378 20.669 18.5068 22 16.8649 22H4.97297C3.33104 22 2 20.669 2 19.027V7.13514C2 5.49321 3.33105 4.16217 4.97297 4.16217H10.3784C10.8262 4.16217 11.1892 4.52518 11.1892 4.97298C11.1892 5.42077 10.8262 5.78379 10.3784 5.78379H4.97297Z",
    fill: "#4B4F5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboardingEdit);
export default __webpack_public_path__ + "static/media/onboarding-edit.ff3266834881d810d83d2e875183200a.svg";
export { ForwardRef as ReactComponent };